import {
    Truck,
    GraduationCap,
    Building2,
    Store,
    Landmark,
    Users,
} from "lucide-react";

const CLIENTS_IMG =
    "https://customer-assets.emergentagent.com/job_creaciones-pro/artifacts/dvomcv2b_socios-clientes.webp";

const clients = [
    {
        icon: Truck,
        name: "Distribuidoras Regionales y Locales",
        description:
            "Nuestro mercado principal de mayoreo, compuesto por empresas que adquieren grandes volúmenes de stock para su posterior redistribución en diferentes zonas geográficas.",
    },
    {
        icon: GraduationCap,
        name: "Centros Educativos y Universidades",
        description:
            "Instituciones que requieren surtido masivo y programado de materiales de papelería para sus ciclos escolares y áreas administrativas.",
    },
    {
        icon: Building2,
        name: "Corporativos y Despachos Profesionales",
        description:
            "Empresas que buscan centralizar sus compras de artículos de oficina con un proveedor que garantice entrega directa y precios competitivos.",
    },
    {
        icon: Store,
        name: "Comercios Minoristas y Papelerías",
        description:
            "Pequeños negocios que se apoyan en nosotros como su distribuidor de cabecera para mantener su inventario siempre actualizado.",
    },
    {
        icon: Landmark,
        name: "Dependencias Gubernamentales",
        description:
            "Organismos públicos que realizan adquisiciones por volumen de consumibles y papelería técnica para su operación diaria.",
    },
    {
        icon: Users,
        name: "Público General y Estudiantes",
        description:
            "Usuarios finales que acuden a nuestra venta al por menor buscando calidad y atención especializada para sus proyectos personales.",
    },
];

export default function Clients() {
    return (
        <section
            id="clientes"
            data-testid="clients-section"
            className="py-20 lg:py-32 bg-white"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                {/* Header banner */}
                <div className="grid lg:grid-cols-12 gap-10 items-end mb-14 fade-up">
                    <div className="lg:col-span-7">
                        <span className="opteris-chip">
                            Socios y Clientes Potenciales
                        </span>
                        <h2
                            data-testid="clients-heading"
                            className="font-display font-black text-3xl sm:text-4xl lg:text-5xl tracking-tight mt-5 leading-[1.1]"
                        >
                            Nuestros{" "}
                            <span className="text-[#f4861c]">socios</span> y
                            clientes potenciales
                        </h2>
                        <p className="mt-5 text-gray-600 max-w-xl text-base sm:text-lg leading-relaxed">
                            Atendemos a una red diversa de compradores: desde
                            grandes distribuidoras hasta el consumidor final
                            que busca calidad y atención especializada.
                        </p>
                    </div>
                    <div className="lg:col-span-5">
                        <div className="rounded-2xl overflow-hidden border border-gray-100 h-56">
                            <img
                                src={CLIENTS_IMG}
                                alt="Corporativo"
                                className="w-full h-full object-cover"
                            />
                        </div>
                    </div>
                </div>

                {/* Grid */}
                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
                    {clients.map((c, i) => {
                        const Icon = c.icon;
                        return (
                            <div
                                key={i}
                                data-testid={`client-card-${i}`}
                                className="opteris-card p-7 group fade-up"
                            >
                                <div className="w-12 h-12 rounded-xl bg-[#ea4d87]/10 text-[#ea4d87] flex items-center justify-center group-hover:bg-[#ea4d87] group-hover:text-white transition-colors">
                                    <Icon size={22} />
                                </div>
                                <h3 className="font-display font-bold text-lg mt-5 leading-tight">
                                    {c.name}
                                </h3>
                                <p className="mt-3 text-sm text-gray-600 leading-relaxed">
                                    {c.description}
                                </p>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
